import React from 'react';
import { Box } from '@mui/material';

/** Full-viewport shell — prevents document-level overscroll bounce. */
export default function AppShell({ children, sx }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
